var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { v4 } from 'uuid';
// Ensures Webpack compilation in React 17 environments
// see: https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
var ReactCopy = __assign({}, React);
var reactUseId = ReactCopy.useId;
var reactUseMemo = ReactCopy.useMemo;
/**
 * Returns a unique ID for use in accessibility attributes which is also a valid
 * CSS identifier.
 *
 * In React 18+, leverages `useId`, replacing colons with underscores to ensure
 * compliance with CSS identifier spec.
 *
 * In React <=17, the id generated will be random and CSS-compliant, however it
 * will not be stable across server and client in the same way as `useId`.
 *
 * @example <caption>React 18+</caption>
 * const id = useSafeId(); // '_r0_'
 *
 * @example <caption>React 16/17</caption>
 * const id = useSafeId(); // 'a744113bd-de16-4097-86dc-97570dc73a4b'
 */
export function useSafeId() {
    if (reactUseId) {
        var reactId = reactUseId();
        // The React id starts and ends with ':' which is an invalid CSS
        // identifier. See: https://github.com/facebook/react/issues/26839
        return reactId.replace(/:/g, '_');
    }
    return reactUseMemo(function () { return "a".concat(v4()); }, []);
}
//# sourceMappingURL=useSafeId.js.map